<!--
  There was no way past the navbar: every route puts the full header ahead of the content
  (WCAG 2.4.1). Off-screen until focused, which is the one approved visual addition here -
  it appears only for a keyboard user, on the first Tab of the page.

  The click is handled rather than left to the `href` so the router does not treat the
  fragment as a navigation, and so focus actually moves - `#main-content` is only
  programmatically focusable.
-->
<a class="skip-to-content" href="#main-content" (click)="skipToContent($event)" data-test-id="app-skip-to-content">Skip to main content</a>

<!--
  Route changes swapped the outlet with nothing announced, so a screen-reader user was left
  wherever they were with no indication the page had changed (WCAG 4.1.3). The document
  title is what PageTitleStrategy has just set for the new route.
-->
<p class="visually-hidden-announcer" role="status" aria-live="polite" data-test-id="app-route-announcer">{{ routeAnnouncement }}</p>

@if (themeName === themeNames.BluePulse) {
  <app-navbar
    (logOut)="logout()"
    [logoUrl]="logo$ | async"
    [userName]="userName"
    [selectedMpiId]="selectedMpiId"
    [wards]="wards$ | async"
    [currentUserClaims]="currentUserClaims"
    [logoRedirectUrl]="logoRedirectUrl"
    data-test-id="app-navbar-2"
    />
  } @else {
    @if (runShimmerLoader) {
      <app-shimmer-loading-patientweb data-test-id="app-shimmer-loading-patientweb" />
    }

    <div [ngClass]="{'appIsLoading': runShimmerLoader}" data-test-id="app-navbar"  class="navbar-wrapper" id="navbar-wrapper">
      @if (useNewNav$| async) {
        <syn-synlab-header-switch-profile data-test-id="app-header-switch"  (onLogout)="logout()"></syn-synlab-header-switch-profile>
      }
    </div>
  }

  @if (themeName !== themeNames.BluePulse) {
    <div [ngClass]="{'appIsLoading': runShimmerLoader}" data-test-id="app-header-wrap"  class="page-header-wrap">
      @if (!(useNewNav$| async)) {
        <app-header data-test-id="app-app-header" ></app-header>
      }
    </div>
  }

  <div [ngClass]="{'appIsLoading': runShimmerLoader && !(useNewNav$ | async)}" data-test-id="app-content-wrap"  class="page-content-wrap" [class.ee-tenant]="isEETenant$|async">
    <main id="main-content" tabindex="-1" data-test-id="app-container"  class="s-container">
      <router-outlet data-test-id="app-router-outlet" ></router-outlet>
    </main>
  </div>

  <app-popup-unauthorized data-test-id="app-popup-unauthorized" ></app-popup-unauthorized>
